<div class="theme-settings">
  <div class="color-pickers">
    @let primaryStyle = primary();
    @if (primaryStyle) {
      <div class="color-picker-entry">
        <andor-color-picker
          (changedColor)="onColorChange(primaryStyle.id, $event)"
          label="{{ 'Primary Color' | translate }}"
          [initialColor]="primaryStyle[mode()]"></andor-color-picker>
      </div>
    }
    @let accentStyle = accent();
    @if (accentStyle) {
      <div class="color-picker-entry">
        <andor-color-picker
          (changedColor)="onColorChange(accentStyle.id, $event)"
          label="{{ 'Accent Color' | translate }}"
          [initialColor]="accentStyle[mode()]"></andor-color-picker>
      </div>
    }
  </div>
  <div class="entry">
    <andor-image-upload
      (fileSelected)="onFileSelected($event, logoKey())"
      (removed)="onFileRemoved(logoKey())"
      [item]="logo()"
      [description]="'Drag or click to upload a Logo' | translate"
      [noFileSelectedText]="'No Logo selected' | translate"></andor-image-upload>
    <andor-image-upload
      (fileSelected)="onFileSelected($event, backgroundKey())"
      (removed)="onFileRemoved(backgroundKey())"
      [item]="background()"
      [description]="'Drag or click to upload a Background' | translate"
      [noFileSelectedText]="'No Background selected' | translate"></andor-image-upload>
  </div>
</div>
